import React from "react";
import ProjectsUi from "../components/ProjectsUi";

const Projects = () => {
  return (
    <>
      <ProjectsUi />
    </>
  );
};

export default Projects;
